import React, { useState, useRef, useEffect } from 'react';
import {
  SidebarWrapper, LogoArea, LogoInitialsAvatar, LogoTenantName,
  NavScroll, NavItem, NavItemLabel, NavChevron, NavBadge,
  NavIconWrapper, NavBadgeDot,
  SubMenu, SubItem, SidebarDivider, BottomSection,
} from './styles';
import { sideBarData, sideBarDataPartners, sideBarDataSuperAdmin } from '../../route-menus';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthTenant, useAuthUser } from 'store/auth';
import { hasModulePermission, hasPermission } from 'utils/permission_utils';
import { getTenant } from 'utils/tenant_utils';
import { changeStatusMenu, useMenuStatus } from 'store/menu';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { getBrandingForDisplay } from 'services/company-service';
import { getTotalCountUserNotification } from 'services/user-notifications-service';

const HomeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
)

const GearIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
)

const SignatureIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/>
    <path d="m15 5 4 4"/>
  </svg>
)

const DocumentIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
  </svg>
)

const ChartIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
)

const ReportIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <polyline points="16 13 12 17 8 13"/>
  </svg>
)

const BellIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </svg>
)

const HelpIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
)

const HandshakeSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m11 17 2 2a1 1 0 1 0 3-3"/>
    <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l1.71 1.15a5.77 5.77 0 0 0 5.48.5L21 4"/>
    <path d="m21 3 1 11h-1"/>
    <path d="M4.64 4.55a2 2 0 0 0-1.41 1.41L2 10l5.5 1 .5-1"/>
    <path d="m15 5-3 3"/>
  </svg>
)

const GlobeSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
)

const ChevronDownSvg = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
)

const ICON_MAP = {
  '/img/icons/home.svg': <HomeIcon />,
  '/img/icons/gear.svg': <GearIcon />,
  '/img/icons/signature.svg': <SignatureIcon />,
  '/img/icons/file3.svg': <DocumentIcon />,
  '/img/icons/chart.svg': <ChartIcon />,
  '/img/icons/report.svg': <ReportIcon />,
}

const SECTION_ICON_OVERRIDES = {
  'Configurações Globais': <GlobeSvg />,
  'Parceiros': <HandshakeSvg />,
  'Gestão de Riscos de Terceiros': <HandshakeSvg />,
}

const renderIcon = (item) => {
  if (SECTION_ICON_OVERRIDES[item.title]) return SECTION_ICON_OVERRIDES[item.title]
  if (typeof item.icon === 'string') return ICON_MAP[item.icon] || null
  return null
}

const getInitials = (name) => {
  if (!name) return 'VO'
  const parts = name.trim().split(' ').filter(Boolean)
  if (parts.length === 1) return parts[0][0].toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

const MenuSection = ({ items, user, openMenu, activeMenu, handleMenus, closeMenu, t }) => (
  <>
    {items.map((item, i) =>
      hasModulePermission(user.permissions, item.permissions) && (
        <React.Fragment key={`section-${i}`}>
          <NavItem
            $active={activeMenu === item.title}
            $collapsed={!openMenu}
            onClick={() => handleMenus(item)}
            title={!openMenu ? t(item.titleKey) : ''}
          >
            {renderIcon(item)}
            {openMenu && <NavItemLabel>{t(item.titleKey)}</NavItemLabel>}
            {openMenu && item.children && (
              <NavChevron $open={activeMenu === item.title}>
                <ChevronDownSvg />
              </NavChevron>
            )}
          </NavItem>
          {openMenu && activeMenu === item.title && item.children && (
            <SubMenu>
              {item.children.map(sub =>
                hasPermission(user.permissions, sub.permission) ? (
                  <SubItem
                    key={`${sub.permission}-${sub.link}`}
                    as={Link}
                    to={sub.link}
                    onClick={() => { if (openMenu) closeMenu(); }}
                  >
                    {t(sub.titleKey)}
                  </SubItem>
                ) : null
              )}
            </SubMenu>
          )}
        </React.Fragment>
      )
    )}
  </>
)

export const SideBar = () => {
  const dispatch = useDispatch();
  const user = useSelector(useAuthUser);
  const selectedTenant = useSelector(useAuthTenant);
  const openMenu = useSelector(useMenuStatus);
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState('');
  const { t } = useTranslation('common');
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (e.target.closest('[data-sidebar-toggle]')) return;
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        dispatch(changeStatusMenu());
      }
    };
    if (openMenu) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openMenu, dispatch]);

  const { data: brandingData } = useQuery(['company-branding', selectedTenant?.slug], getBrandingForDisplay, {
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  const logoUrl = brandingData?.data?.branding?.logoUrl;

  const { data: totalUserNotifications } = useQuery(
    ['getTotalCountUserNotification-sidebar', user.userId, selectedTenant?.slug],
    async () => {
      if (!selectedTenant?.slug) return 0;
      const result = await getTotalCountUserNotification(user.userId, selectedTenant.slug);
      return result?.data?.total || 0;
    },
  );

  const handleMenus = (item) => {
    if (!openMenu) {
      dispatch(changeStatusMenu());
    }
    setActiveMenu(prev => prev === item.title ? '' : item.title);
  };

  return (
    <SidebarWrapper ref={sidebarRef} className={openMenu ? 'menu-open' : 'menu-close'}>
      <LogoArea onClick={() => dispatch(changeStatusMenu())}>
        {openMenu ? (
          logoUrl ? (
            <>
              <LogoInitialsAvatar>{getInitials(selectedTenant?.name)}</LogoInitialsAvatar>
              <LogoTenantName>{selectedTenant?.name}</LogoTenantName>
            </>
          ) : (
            <img src="/img/logo-horizontal-white.png" height="28" alt="Virtual Officer" style={{ objectFit: 'contain' }} />
          )
        ) : (
          <img src="/img/icons/logo-mini.png" height="28" alt="VO" style={{ objectFit: 'contain' }} />
        )}
      </LogoArea>

      <NavScroll>
        <NavItem
          $collapsed={!openMenu}
          title={!openMenu ? t('sidebar.dashboard') : ''}
          onClick={() => {
            navigate('/dashboard');
            if (!openMenu) dispatch(changeStatusMenu());
          }}
        >
          <HomeIcon />
          {openMenu && <NavItemLabel>{t('sidebar.dashboard')}</NavItemLabel>}
        </NavItem>

        <MenuSection
          items={sideBarData}
          user={user}
          openMenu={openMenu}
          activeMenu={activeMenu}
          handleMenus={handleMenus}
          closeMenu={() => dispatch(changeStatusMenu())}
          t={t}
        />

        {getTenant() === 'vo' && (
          <>
            <SidebarDivider />
            <MenuSection
              items={sideBarDataSuperAdmin}
              user={user}
              openMenu={openMenu}
              activeMenu={activeMenu}
              handleMenus={handleMenus}
              closeMenu={() => dispatch(changeStatusMenu())}
              t={t}
            />
          </>
        )}

        {selectedTenant?.partner === true && (
          <>
            <SidebarDivider />
            <MenuSection
              items={sideBarDataPartners}
              user={user}
              openMenu={openMenu}
              activeMenu={activeMenu}
              handleMenus={handleMenus}
              closeMenu={() => dispatch(changeStatusMenu())}
              t={t}
            />
          </>
        )}
      </NavScroll>

      <BottomSection>
        <NavItem
          $collapsed={!openMenu}
          title={!openMenu ? t('sidebar.notifications') : ''}
          onClick={() => {
            navigate('/user-notifications');
            if (!openMenu) dispatch(changeStatusMenu());
          }}
        >
          <NavIconWrapper>
            <BellIcon />
            {!openMenu && totalUserNotifications > 0 && (
              <NavBadgeDot>{totalUserNotifications > 99 ? '99+' : totalUserNotifications}</NavBadgeDot>
            )}
          </NavIconWrapper>
          {openMenu && <NavItemLabel>{t('sidebar.notifications')}</NavItemLabel>}
          {openMenu && totalUserNotifications > 0 && (
            <NavBadge>{totalUserNotifications > 99 ? '99+' : totalUserNotifications}</NavBadge>
          )}
        </NavItem>
        <NavItem
          $collapsed={!openMenu}
          title={!openMenu ? t('sidebar.help') : ''}
        >
          <HelpIcon />
          {openMenu && <NavItemLabel>{t('sidebar.help')}</NavItemLabel>}
        </NavItem>
      </BottomSection>
    </SidebarWrapper>
  );
};
